import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronTop"><Path d="M4 15L12 7L20 15" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronTop;
